export const soundUtils = {
    correctAnswer: require('../resources/sounds/correct-answer.mp3'),
    wrongAnswer: require('../resources/sounds/wrong-answer.mp3'),
};
